import {
  ContractItem,
  ContractPrestationType,
  ContractsList,
  ContractType,
  IconWrapper,
  StyledContainer,
  TimelineContainer,
  TimelineDate,
  TimelineDateGroup,
  TimelineLine,
} from './styled-components'
import useTabBar from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useTabBar'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconCarbonRotate360 from '@/shared/icons/IconCarbonRotate360'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconUser from '@/shared/icons/NewDesign/IconUser'
import IconPhone from '@/shared/icons/NewDesign/IconPhone'
import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import { useSelector } from 'react-redux'
import { selectAdditionalContactSubscriptionData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import HistoricSalesEmpty from '@/containers/SubscriptionFormPageNew/Components/HistoricSales/HistoricSalesEmpty'
import useHistoricSalesNotifications from '@/containers/SubscriptionFormPageNew/Components/HistoricSales/useHistoricSalesNotifications'

const HistoricSales = () => {
  const { pushToOpenedContracts, groupedContractsByDate, t } = useTabBar()

  const { expanded, toggle } = useModuleCollapse('historic-sales')
  useHistoricSalesNotifications(groupedContractsByDate, expanded)

  const getTypeIcon = type => {
    switch (type) {
      case 'energy':
        return <IconBolt size={20} style={{ verticalAlign: 'middle' }} />
      case 'insurance':
        return <IconShieldPerson size={20} style={{ verticalAlign: 'middle' }} />
      case 'telecom':
        return <IconPhone size={19} style={{ verticalAlign: 'middle' }} />
      default:
        return null
    }
  }

  const additionalClient = useSelector(selectAdditionalContactSubscriptionData)

  const clientCreationItem =
    additionalClient && additionalClient.createdAt
      ? {
          date: additionalClient.createdAt.split(' ')[0],
          isClientCreation: true,
          contracts: [],
        }
      : null

  if (groupedContractsByDate.length === 0) {
    return <HistoricSalesEmpty t={t} expanded={expanded} toggle={toggle} />
  }

  const timelineItems = clientCreationItem ? [clientCreationItem, ...groupedContractsByDate] : groupedContractsByDate

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonRotate360} moduleKey='historic-sales'>
          {t('subscriptionTools:historic_contracts.module_title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='historic-sales' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <TimelineContainer>
          {timelineItems.map(({ date, contracts, isClientCreation }, index) => (
            <div key={`${date}-${index}`}>
              {index === 0 && (
                <TimelineLine $last={index === groupedContractsByDate.length - 1} $itemsCount={contracts.length} />
              )}
              <TimelineDateGroup>
                <TimelineDate>{date}</TimelineDate>
                <ContractsList>
                  {isClientCreation ? (
                    <ContractItem>
                      <ContractType>
                        <IconWrapper>
                          <IconUser size={19} />
                        </IconWrapper>
                        <span>{t('subscriptionTools:historic_contracts.client_creation')}</span>
                      </ContractType>
                    </ContractItem>
                  ) : (
                    contracts.map(contract => (
                      <ContractItem key={contract.id} onClick={() => pushToOpenedContracts(contract)}>
                        <ContractType>
                          <IconWrapper>{getTypeIcon(contract.type)}</IconWrapper>
                          <span>
                            {t(`common:${contract.type}_sale`)} ({contract.characteristics.providerName})
                          </span>
                        </ContractType>
                        <ContractPrestationType>{contract.characteristics.prestationType}</ContractPrestationType>
                      </ContractItem>
                    ))
                  )}
                </ContractsList>
              </TimelineDateGroup>
            </div>
          ))}
        </TimelineContainer>
      </ModuleContent>
    </StyledContainer>
  )
}

export default HistoricSales
